<template>
  <div class="px-page mb-8 text-center py-12">
    <div class="space-y-2">
      <div class="text-3xl font-extrabold tracking-tight sm:text-4xl">Import Orders from Shopify</div>
      <div class="text-2xl font-semibold tracking-tight sm:text-3xl">Enter one or more orders seperated by comma.</div>
    </div>

    <div class="mt-12 mx-auto max-w-lg space-y-6">
      <label for="orderNumbers" class="sr-only">Order Numbers</label>
      <input v-model="orderNumbers" type="text" class="block w-full rounded-md border-gray-300 shadow-sm text-center focus:border-primary-500 focus:ring-primary-500 sm:text-2xl" placeholder="ORDER NUMBERS" />
      <button v-on:click="importOrders()" type="button" class="btn btn-xl btn-primary">Import Orders</button>
    </div>
  </div>
</template>

<script setup>

import {ref} from "vue";
import {Link, router} from "@inertiajs/vue3";
import {ArrowPathIcon} from "@heroicons/vue/24/outline";

const orderNumbers = ref("");

function importOrders() {
  router.post(route("customs.import.store"), {
    order_numbers: orderNumbers.value
  });
}

</script>
